
    import './styles.scoped.css';
    export default {
  "text-content": "awsui_text-content_6absk_1n72z_10"
};
  